/**
 * Mailer Template List Component
 */
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import EyeIcons from '@/icons/EyeIcons'
import EditIcons from '@/icons/EditIcons'
import { paths } from '@/utils/path'
import { useNavigate } from 'react-router-dom'
import type { MailerTemplate } from '../../types'
import { useMailerTemplateList } from '../../hooks/use-mailer-template-list'

const TemplateList: React.FC = () => {
    const navigate = useNavigate()

    const {
        templates,
        pagination,
        stateComponent,
        params,
        searchInputProps,
        columns,
        handlePageChange,
        handlePageSizeChange,
        handleSortChange,
        t,
    } = useMailerTemplateList()

    return (
        <Paper className="space-y-2 my-2">
            {stateComponent || (
                <DataTableCustomized<MailerTemplate>
                    columns={columns}
                    rows={templates}
                    rowKey={(row) => row.mailer_template_id}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('mailerCampaign:search_template'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'mailer-template-list',
                        },
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    actions={[
                        {
                            key: 'view',
                            label: t('view'),
                            icon: <EyeIcons />,
                            onClick: (row) =>
                                navigate(
                                    paths.mailerTemplateDetail.replace(
                                        ':id',
                                        String(row.mailer_template_id)
                                    )
                                ),
                        },
                        {
                            key: 'edit',
                            label: t('edit'),
                            icon: <EditIcons />,
                            onClick: (row) =>
                                navigate(
                                    paths.mailerTemplateEdit.replace(
                                        ':id',
                                        String(row.mailer_template_id)
                                    )
                                ),
                        },
                    ]}
                />
            )}
        </Paper>
    )
}

export default TemplateList
